<template>
  <div>
      <video autoplay muted loop class="hover_video" src="@/assets/video/digitalcareer.mp4"></video>
      <p class="description pd-top-40">
        Hiring Team dari MNC Group menyelenggarakan Virtual Job Fair bertema MNC Digital Career Fest. Digital Career Fest ini diadakan untuk menjaring talenta-talenta berpotensi untuk mengisi lebih dari 50  lowongan kerja dibidang digital antara lain IT Developer, Data Scientist, Mobile Application, Games Developer, Digital Marketing, Digital Sales, dan masih banyak lagi.  
      </p>
      <!-- <p class="link description mg-top-20" @click="movePage()">Selengkapnya</p> -->
  </div>
</template>

<script>
export default {
  name: 'Digital',
  data () {
    return {

    }
  },
  methods: {
    movePage() {
      this.$router.push('/digital-career')
    }
  }
}
</script>
